export default "__VITE_ASSET___iNujupr__"